(function () {
    "use strict";

    cc_Config.interviewButtonOptions = {
        showOnTop: false
    };

    cc_EntityIntegration.createDefaultScreen = function () {

        return '<div id="cloudcase-form-container">' +
            '<div id="cloudcase-page-navigator">' +
            '<div id="cloudcase-page-navigator-header" class="icon icon-logo">' +
                '<svg width="108" height="27" viewBox="0 0 108 27" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<path d="M51.7402 7.84704H46.825V4.33105H61.9704V7.84704H57.0552V22.1156H51.7402V7.84704Z" fill="#1A1C45"/>' +
                    '<path d="M64.6411 17.7328C66.013 18.395 67.9275 18.9053 70.1278 18.9053C71.8136 18.9053 73.4143 18.599 73.4143 17.1721C73.4143 13.8601 63.9836 15.9492 63.9836 9.4772C63.9836 5.19735 68.6701 4.0249 72.6709 4.0249C74.5862 4.0249 76.4719 4.27999 77.8149 4.68788L77.822 8.35663C76.4501 7.79598 74.5574 7.54086 73.0426 7.54086C71.6996 7.54086 69.4712 7.64322 69.4712 9.19723C69.4712 12.0765 78.9011 10.1402 78.9011 16.5603C78.9011 21.1727 74.5574 22.4212 70.1279 22.4212C68.2703 22.4212 66.2816 22.1661 64.5092 21.6567L64.6411 17.7328Z" fill="#1A1C45"/>' +
                    '<path d="M81.6141 4.33105H90.787C94.5021 4.33105 97.274 5.78349 97.274 8.84114C97.274 11.083 95.988 12.3315 93.7596 12.9938V13.045C96.4167 13.5289 97.7886 14.803 97.7886 16.9681C97.7886 21.2238 93.5878 22.1156 90.0156 22.1156H81.6141V4.33105ZM86.929 11.363H88.4157C90.1585 11.363 91.959 10.9807 91.959 9.47784C91.959 7.84704 90.2444 7.69427 88.4727 7.69427H86.929V11.363ZM86.929 18.7524H88.5008C90.4443 18.7524 92.4736 18.4973 92.4736 16.6881C92.4736 14.7518 90.3873 14.5734 88.5578 14.5734H86.929V18.7524Z" fill="#1A1C45"/>' +
                    '<path d="M23.4126 12.6063V0C18.2303 7.25708 9.76168 12.2877 0 13.2233C9.76168 14.1582 18.2303 19.1887 23.4126 26.4465V13.8395C17.5393 13.8416 11.8019 13.5712 6.21369 13.2233C11.8019 12.8746 17.5393 12.6034 23.4126 12.6063Z" fill="#0B794B"/>' +
                    '<path d="M23.4124 12.6063V0C28.5954 7.25708 37.0632 12.2877 46.8249 13.2233C37.0632 14.1582 28.5954 19.1887 23.4124 26.4465V13.8395C29.2856 13.8416 35.023 13.5712 40.6112 13.2233C35.023 12.8746 29.2856 12.6034 23.4124 12.6063Z" fill="#29B58B"/>' +
                '</svg>' +
                '<div id="cloudcase-page-navigator-close" onclick="closeNavigator()">' +
                    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M17.3282 2.67205C17.8187 3.16261 17.8187 3.95797 17.3282 4.44853L4.44873 17.328C3.95817 17.8185 3.16282 17.8185 2.67226 17.328C2.1817 16.8374 2.1817 16.0421 2.67226 15.5515L15.5517 2.67205C16.0423 2.18149 16.8376 2.18149 17.3282 2.67205Z" fill="currentColor"/>' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M17.3281 17.3279C16.8375 17.8185 16.0422 17.8185 15.5516 17.3279L2.67215 4.44849C2.18159 3.95793 2.18159 3.16257 2.67215 2.67201C3.16271 2.18145 3.95807 2.18145 4.44863 2.67201L17.3281 15.5515C17.8186 16.042 17.8186 16.8374 17.3281 17.3279Z" fill="currentColor"/>' +
                    '</svg>' +
                '</div>' +
            '</div>' +
            '<ul id="cloudcase-page-navigator-unrestricted"></ul>' +
            '<ul id="cloudcase-page-navigator-restricted"></ul>' +
            '<div class="saveButtonPanel" style="margin-top: 20px;">' +
            `<button class='btn save'>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.15015 0.851562C1.88942 0.851562 0.851562 1.88945 0.851562 3.15013V13.8863C0.851562 15.1478 1.88946 16.1849 3.15015 16.1849H13.8878C15.1492 16.1849 16.1849 15.147 16.1849 13.8863V4.68398C16.1863 4.48056 16.1073 4.28506 15.9649 4.1406L12.8965 1.07216C12.8009 0.978725 12.683 0.912598 12.5536 0.878813L3.15015 0.851562ZM3.15015 2.38539H3.91996V6.21781C3.92139 6.63901 4.26281 6.97969 4.684 6.98184H12.3533C12.7745 6.9804 13.1152 6.63899 13.1174 6.21781V3.46494L14.6527 5.00022V13.887C14.6527 14.3247 14.3271 14.6525 13.8886 14.6525L3.15028 14.6511C2.71255 14.6511 2.38624 14.324 2.38624 13.8856V3.14937C2.38624 2.71093 2.71183 2.38388 3.15028 2.38388L3.15015 2.38539ZM5.45316 2.38539H11.5827V5.45383H5.45316V2.38539ZM4.68335 8.51637C4.26 8.51781 3.91786 8.86281 3.91931 9.28617V12.3531C3.92075 12.7743 4.26217 13.115 4.68335 13.1172H12.3527C12.7739 13.1157 13.1146 12.7743 13.1167 12.3531V9.28617C13.1182 8.86281 12.7767 8.51781 12.3527 8.51637H4.68335ZM5.45316 10.0502H11.5827V11.584H5.45316V10.0502Z"/>
                    </svg>
                    <span>Save & Exit</span>
                </button>` +
            '</div>' +
            '</div>' +
            '<div id="cloudcase-page-container">' +
            '<div id="page">' +
            '<div id="page-content" class="panel-group"></div>' +
            '</div>' +
            cc_View.createFooter() +
            '</div>' +
            '</div>';
    };

    cc_EntityIntegration.getQuestions = function (allowFindingsGeneration, task, callback) {
        if (cip_Entity.onPreGetQuestions) {
            cip_Entity.onPreGetQuestions(cip_Common.brandId, cip_Common.formId, cc_Config.application, task);
        }

        var interviewAccessContext = 'DEFAULT';
    
        var interviewChangeTimestamp = null;
        if (typeof cc_Config != "undefined" && typeof cc_Config.application != "undefined" && typeof cc_Config.application.interview != "undefined") {
          interviewChangeTimestamp = cc_Config.application.interview.changeTimestamp;
        }
		
        var interviewContext = {
          accessContext : interviewAccessContext,
          changeTimestamp : interviewChangeTimestamp
        }

        cc_Ajax.serialRequest({
            url: cip_Common.toApplicationUrl() + '/' + cc_Config.applicationId + '/interview/edit',
            type: 'POST',
            throbberDelay: task && task.isUserDriven === false ? 10000 : 800,
            data: function () {
                return {
                    interviewContext : cc_Util.stringify(interviewContext),
                    answeredQuestions: cc_Util.stringify(cc_Renderer.dettachQuestions(), cc_Config.uploadCompression.answeredQuestions),
                    allowFindingsGeneration: allowFindingsGeneration
                }
            },
            cleanSkippedResponse: function (response) {
                if (response && response.selectedApplication && response.selectedApplication.detail && response.selectedApplication.detail.interview) {
                    response.selectedApplication.detail.interview.findingsRegenerated = false;
                }
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    cc_Model.isInterviewComplete = false;

                    if (response && response.selectedApplication && response.selectedApplication.detail) {
                        cc_Model.isInterviewComplete = response.selectedApplication.detail.submissionStatus == "SUBMISSION_COMPLETE";
                    }
                    
                    if (response && response.selectedApplication && response.selectedApplication.operation) {
                    	cc_Model.updateInterviewMode(response.selectedApplication.operation);
                    }

                    var interview = null;

                    if (response.selectedApplication) {
                        cc_Config.application = response.selectedApplication.detail;
                        cc_Config.workflowName = cc_Config.application.workflowName;
                        cc_Config.rulebookName = cc_Config.application.rulebookName;
                        cc_Config.rulebookVersion = cc_Config.application.rulebookVersion;
                        cc_Config.serverVersionOnRulebookSave = cc_Config.application.interview.serverVersionOnRulebookSave;

                        interview = cc_Config.application.interview;
                    }

                    cc_Controller.handleGetQuestionResponse(interview, task, callback);

                    if (task && task.triggerType === "SAVE") {
                        cip_Entity.showApplicationSaveAsDialog(cip_Common.brandId, cip_Common.formId, cc_Config.application);
                    }
                }
            }
        });
    };

    cc_EntityIntegration.addDocumentToQuestion = function (applicationId, questionId, form) {
        var options = {
            type: 'POST',
            data: {},
            useShortThrobberKey: true,
            url: cip_Common.toApplicationUrl() + '/' + applicationId + '/add/question/' + questionId + '/document',
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    if (response.invalidInputs && response.invalidInputs.length > 0) {
                        // only show the first error if there is more than one
                        cc_Renderer.attachError(questionId, response.invalidInputs[0].description, "server");
                    } else {
                        var task = {
                            triggerType: "ADD_DOCUMENT",
                            manuallySelectedPageId: null,
                            enableMoveToRelativePage: false,
                            isUserDriven: false,
                            focusedQuestionId: cc_UI.getFocusedQuestionId()
                        };

                        cc_Controller.handleResponse(response.selectedApplication.detail.interview, task);
                    }
                }
            }
        };

        // we need to add manually since form.ajaxSubmit does not used the
        // $.ajaxSetup defaults
        options = $.extend({}, cc_Ajax.defaults, options);

        // increase timeout for slow internet connections
        options.timeout = 1000 * 60 * 5; // 5 mins;

        form.ajaxSubmit(options);
    };

    cc_EntityIntegration.removeDocumentFromQuestion = function (applicationId, questionId, documentId, successCallback) {
        cc_Ajax.serialRequest({
            url: cip_Common.toApplicationUrl() + '/' + applicationId + '/delete/question/' + questionId + '/document/' + documentId,
            type: 'POST',
            data: {},
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    var task = {
                        triggerType: "REMOVE_DOCUMENT",
                        manuallySelectedPageId: null,
                        enableMoveToRelativePage: false,
                        isUserDriven: false,
                        focusedQuestionId: cc_UI.getFocusedQuestionId()
                    };
                    cc_Controller.handleResponse(response.selectedApplication.detail.interview, task);
                }
            }
        });
    };

    cc_EntityIntegration.saveUnsubmittedApplicationToCompleteLater = function (applicationId, email, mobilePhoneNumber, successCallback) {
        $.ajax({
            url: cip_Common.toApplicationUrl() + '/' + applicationId + '/save/completelater',
            type: 'POST',
            data: {
                email: email,
                mobilePhoneNumber: mobilePhoneNumber,
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    successCallback(response);
                }
            }
        });
    };

    cc_EntityIntegration.sendApplicantSessionActivationSmsCode = function (successCallback) {
        $.ajax({
            url: cip_Common.toApplicationUrl() + '/authentication/sms/send',
            type: 'POST',
            data: {},
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    successCallback(response);
                }
            }
        });
    };

    cc_EntityIntegration.activateApplicantSessionUsingSmsCode = function (smsCode, successCallback) {
        $.ajax({
            url: cip_Common.toApplicationUrl() + '/authentication/sms/activate',
            type: 'POST',
            data: {
                smsCode: smsCode
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    window.location.reload();
                }
            }
        });
    };

    cc_EntityIntegration.activateApplicantSessionUsingCustomerDetails = function (email, firstName, lastName, representativeName, successCallback) {
        $.ajax({
            url: cip_Common.toApplicationUrl() + '/authentication/customerdetails/activate',
            type: 'POST',
            data: {
                email: email,
                firstName: firstName,
                lastName: lastName,
                representativeName: representativeName
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    window.location.reload();
                }
            }
        });
    };

    cc_EntityIntegration.getSearchDataSourceResults = function (dataSourceReference, searchValue, successCallback) {
        $.ajax({
            type: 'POST',
            url: cip_Common.toApplicationUrl() + '/' + cc_Config.applicationId + '/datasource/search',
            throbber: false,
            data: {
                workflowName: cc_Config.workflowName,
                rulebookName: cc_Config.rulebookName,
                dataSourceReference: cc_Util.stringify(dataSourceReference),
                search: searchValue
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    successCallback(response);
                }
            }
        });
    };

    cc_EntityIntegration.startApplication = function (successCallback, parameters) {
        var initialQuestionStates = [];

        var urlParameters = parameters ? parameters : cc_Util.getUrlVars();
        if (urlParameters) {
            $.each(urlParameters, function () {
                var value = urlParameters[this] != null ? urlParameters[this].split("|") : null; // FirstName=Bill%7Ctrue

                if (value) {
                    var initialQuestionState = {
                        id: this
                    };

                    if (value[0]) {
                        initialQuestionState.entered = value[0].split(",");
                    }

                    if (value[1]) {
                        initialQuestionState.disabled = (value[1] === "true");
                    }

                    initialQuestionStates.push(initialQuestionState);
                }
            });
        }

        cc_Ajax.serialRequest({
            url: cip_Common.toApplicationFormUrl(cip_Common.formId) + '/interview/start',
            type: 'POST',
            throbberDelay: 0,
            data: function () {
                return {
                    initialQuestionStates: JSON.stringify(initialQuestionStates)
                }
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    successCallback.call(response);
                }
            }
        });
    };

    cc_EntityIntegration.createPreviousButtonText = function (isFirstPageSelected, isLastNonRestrictedPageSelected, isWritableRestrictedPageSelected, isReadyToFinish, isInterviewComplete) {
        return cip_Entity.createPreviousButtonText(cip_Common.brandId, cip_Common.formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete);
    };

    cc_EntityIntegration.createNextButtonText = function (isFirstPageSelected, isLastNonRestrictedPageSelected, isWritableRestrictedPageSelected, isReadyToFinish, isInterviewComplete) {
        return cip_Entity.createNextButtonText(cip_Common.brandId, cip_Common.formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete);
    };

    cc_EntityIntegration.createSaveButtonText = function (isFirstPageSelected, isLastNonRestrictedPageSelected, isWritableRestrictedPageSelected, isReadyToFinish, isInterviewComplete) {
        return cip_Entity.createSaveButtonText(cip_Common.brandId, cip_Common.formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete);
    };

    cc_EntityIntegration.createBookButtonText = function (isFirstPageSelected, isLastNonRestrictedPageSelected, isWritableRestrictedPageSelected, isReadyToFinish, isInterviewComplete) {
        return "Book ";
    };

    cc_EntityIntegration.onPreRendering = function () {
        return cip_Entity.onPreRendering(cip_Common.brandId, cip_Common.formId, cc_Config.application);
    };

    cc_EntityIntegration.onPostRendering = function () {
        cip_Entity.onPostRendering(cip_Common.brandId, cip_Common.formId, cc_Config.application);
    };

    cc_EntityIntegration.onPreFindingsAssessment = function (continuation) {
        cip_Entity.onPreFindingsAssessment(cip_Common.brandId, cip_Common.formId, cc_Config.application, function () {
            // hide questions so that response data is not visible when rendered
            $('#container').hide();
            continuation();
        });
    };

    cc_EntityIntegration.onPostFindingsAssessment = function () {
        cip_Entity.onPostFindingsAssessment(cip_Common.brandId, cip_Common.formId, cc_Config.application);
    };

    cc_EntityIntegration.onPostFindingsReassessment = function () {
        cip_Entity.onPostFindingsReassessment(cip_Common.brandId, cip_Common.formId, cc_Config.application);
    };

    cc_EntityIntegration.onCleanAndRefresh = function () {
        cip_Entity.onCleanAndRefresh(cip_Common.brandId, cip_Common.formId, cc_Config.application);
    };

    cc_EntityIntegration.onPostShowPage = function (page) {
        cip_Entity.onPostShowPage(cip_Common.brandId, cip_Common.formId, cc_Config.application, page)
    }

    cc_EntityIntegration.onPostChangedEnteredValue = function (question, updatedEnteredValue) {
        cip_Entity.onPostChangedEnteredValue(cip_Common.brandId, cip_Common.formId, cc_Config.application, question, updatedEnteredValue);
    };
})();